import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../docuvision/models/user.model';
import { ResponseObjectAPI } from '@models/responseObjectAPI';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private user:User

  constructor(private http: HttpClient) { }

    setUserData( data:User ) {this.user = data}

    getUserData() { return this.user }

    getUsers() {
        return this.http.get(`${environment.apiUrl}/common/user`)
    }

    getUser(userId) {
      return this.http.get(`${environment.apiUrl}/common/user/get/${userId}`)
    }

    getDataUser() {
      return this.http.get(`${environment.apiUrl}/common/user/dataUser`);
    }

    async getDataInfoUser() {
      const response:any = await this.http.get(`${environment.apiUrl}/common/user/dataUser`).toPromise();
      return response.result;
    }


    addUser(user) {
      return this.http.post(`${environment.apiUrl}/common/user/create`, user, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      })
    }

    updateUser(user) {
      return this.http.post(`${environment.apiUrl}/common/user/update`, user, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      })
    }

    removeUser(userId) {
      let data = {
        id: userId,
        active: false
      }
      return this.http.post(`${environment.apiUrl}/common/user/delete`, data, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      })
    }

    getMassiveUploadTemplate() {
      return this.http.get(`${environment.apiUrl}/common/user/massive-upload-template`, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      });
    }

    massiveUploadUsers(fileBase64: string) {
      return this.http.post(`${environment.apiUrl}/common/user/massive-upload`, { file: fileBase64 }, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      });
    }

    resetPasswords(userids: number[]) {
      return this.http.post(`${environment.apiUrl}/common/user/reset-passwords`, { userids }, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      });
    }

    /** Renueva token de setup y reenvía el enlace (1..200). No expone el token. */
    resendInvites(userids: number[]) {
      return this.http.post(`${environment.apiUrl}/common/user/resend-invites`, { userids }, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      });
    }
}
